export default {
  metaTitle: '销售订单',
  pageTitle: '销售订单列表',
  orderStatus: '订单状态',
  payment: '支付方式',
  payStatus: '支付状态',
  userId: '用户ID',
  account: '帐号',
  userPhone: '用户电话',
  addrPhone: '收件电话',
  so: '订单',
  sku: 'SKU',
  listingId: 'Listing',
  placeholder1: 'id或编号',
  placeholder2: 'listing标题',
  userConfirm: '用户确认',
  all: '所有',
  cod: '货到付款',
  online: '在线支付',
  pre: '预付款',
  orderTime: '下单时间',
  payTime: '支付时间',
  completedTime: '完成时间',
  confirmTime: '确认时间',
  unpay: '未支付',
  paid: '已支付',
  saleOrderStatusMap1: '待支付',
  saleOrderStatusMap2: '待确认',
  saleOrderStatusMap3: '待发货',
  saleOrderStatusMap4: '运输中',
  saleOrderStatusMap5: '已收件',
  saleOrderStatusMap6: '补货',
  saleOrderStatusMap7: '取消',
  saleOrderStatusMap8: '拒收',
  saleOrderStatusMap9: '部分收货',
  saleOrderStatusMapInDelivery: '派送中',
  storeIdMap1: 'TopSelective',
  storeIdMap2: 'FlyingGoods',
  storeIdMap3: 'Cost-effective',
  storeIdMap4: 'FashionMall',
  storeIdMap5: 'Digitone',
  storeIdMap6: 'FlashSK',
  clientMap1: 'App',
  clientMap2: 'iOS',
  clientMap3: 'PC',
  clientMap4: 'm站',
  confirm: '确认',
  unconfirmed: '未确认',
  soStates1: '待支付',
  soStates2: '补货中',
  soStates3: '待确认',
  soStates4: '待发货',
  soStates5: '运输中',
  soStates6: '已关闭',
  soStates7: '已取消',
  soStates8: '已完成',
  soStates9: '已拒绝',
  soStates10: '所有进行中',
  soStates11: '已删除',
  closed: '已关闭',
  completed: '已完成',
  yesterday: '昨天',
  yes: '昨天', // 注 yes为Yesterday简写
  today: '今天',
  tod: '今天', // 注 tod为Today简写
  within_7_days: '7日内',
  w7D: '7日内', // 注：7D 意为Within 7 days的简写
  within_30_days: '30日内',
  w30D: '30日内', // 注：30D 意为Within 30 days的简写
  within_3_months: '3月内',
  w3M: '3月内', // 注：3M 意为Within 3 months的简写
  within_1_year: '最近一年',
  w1Y: '最近一年', // 注：1Y 意为Within 1 year的简写
  storeClassName1: '手机',
  storeClassName2: '手机配件',
  storeClassName3: '未分类',
  columns1: '订单编号',
  columns2: '订单ID',
  columns3: '支付方式',
  columns4: '客户端',
  columns5: '类型',
  orderType1: '普通',
  orderType2: '闪购',
  orderType3: '抽奖',
  orderType4: '兑换',
  orderType5: '混合',
  columns6: '用户ID',
  columns7: '国家',
  columns8: '城市',
  columns9: '支付额',
  columns10: '状态',
  store: '店铺',
  contactPhone: '联系电话',
  filename: '文件名',
  logisticsType: '订单物流类型',
  dsCapitalMsg: '抱歉，您当前不能发货，因为您还未开通平台物流帐号。如何开通请点击了解。'
}
